var React = require('react');

function StreamlineFilled35CameraBox (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 4.5C24 2.019 21.981 0 19.5 0h-15C2.019 0 0 2.019 0 4.5v15C0 21.982 2.019 24 4.5 24h15c2.481 0 4.5-2.018 4.5-4.5v-15zM20 16c0 .552-.449 1-1 1H5c-.551 0-1-.448-1-1V9.182C4 8.631 4.449 8 5 8h3.182c.132 0 .259-.053.353-.147l1.892-1.723c.092-.084.212-.13.337-.13h2.472c.125 0 .245.046.337.13l1.892 1.723c.093.094.221.147.353.147H19c.551 0 1 .631 1 1.182V16z","key":0}),React.createElement("circle",{"cx":"18","cy":"10.41","r":".545","key":1}),React.createElement("path",{"d":"M12 8.818c-1.78 0-3.227 1.448-3.227 3.227S10.22 15.274 12 15.274s3.227-1.449 3.227-3.228S13.78 8.818 12 8.818zm0 5.456c-1.228 0-2.227-1-2.227-2.228S10.772 9.818 12 9.818s2.227.999 2.227 2.227-.999 2.229-2.227 2.229z","key":2}),React.createElement("g",{"key":3},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineFilled35CameraBox.displayName = "StreamlineFilled35CameraBox";

StreamlineFilled35CameraBox.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineFilled35CameraBox;

StreamlineFilled35CameraBox.default = StreamlineFilled35CameraBox;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-filled-35-camera-box.svg
// module id = 766
// module chunks = 0